import { RECENT_BUSINESS_DAYS } from "../lib/recent";

/** The one-line "N older …" bar that ends a list collapsed to the current
 *  week. Shared so every long screen collapses the same way and the count is
 *  always visible — a hidden row the user can't see a count for reads as data
 *  loss, which is exactly the confusion this must not create. */
export default function OlderToggle({
  count, open, onToggle, noun = "older",
}: { count: number; open: boolean; onToggle: () => void; noun?: string }) {
  if (count === 0) return null;
  return (
    <button className="w-full text-left text-xs text-slate-500 hover:text-slate-300 font-sans py-2"
            onClick={onToggle}>
      {open ? "▾" : "▸"} {count} {noun}
      {open ? "" : ` — before the last ${RECENT_BUSINESS_DAYS} business days`}
      {open ? " · hide" : " · show"}
    </button>
  );
}
